<div class="admin-modal">
  <h2 class="title">{{ slot.startAt | date:'EEEE d MMM' }}</h2>
  <p class="subtitle">{{ slot.startAt | date:'HH:mm' }} – {{ slot.endAt | date:'HH:mm' }}</p>

  <ul class="meta">
    <li><span>Capacity</span><strong>{{ slot.capacity }}</strong></li>
    <li><span>Booked</span><strong>{{ slot.bookedCount }}</strong></li>
    <li>
      <span>State</span>
      <strong [ngClass]="slot.active ? (slot.available ? 'ok' : 'full') : 'off'">
        {{ slot.active ? (slot.available ? 'Available' : 'Full / past') : 'Inactive' }}
      </strong>
    </li>
  </ul>

  <div class="actions">
    <button type="button" class="btn ghost" (click)="close()">Close</button>
    <button type="button" class="btn" (click)="emit('toggle')">
      {{ slot.active ? 'Deactivate' : 'Activate' }}
    </button>
    <button type="button" class="btn danger" [disabled]="slot.bookedCount > 0"
            [title]="slot.bookedCount > 0 ? 'Has bookings — deactivate instead' : ''"
            (click)="emit('delete')">Delete</button>
  </div>
</div>
